import PropTypes from 'prop-types';
import { useCallback, useMemo, useState } from 'react';

import styles from './styles.module.scss';

import Menu from 'OK/components/menu';
import PageMenu from 'OK/components/menus/page';
import { Tab, Tabs, TabsContextProvider } from 'OK/components/tabs';
import useI18n from 'OK/util/hooks/useI18n';

export default function StaticPagesMenu(props) {
  const { currentSectionTitle, currentTabId } = props;
  const { t } = useI18n();

  const [activeSectionTitle, setActiveSectionTitle] = useState(currentSectionTitle);

  const onChangeActiveSection = useCallback((newActiveSectionTitle) => {
    setActiveSectionTitle(newActiveSectionTitle);
  }, []);

  const pageMenuSubmenu = useMemo(() => {
    switch (activeSectionTitle) {
      case 'Help':
        return (
          <TabsContextProvider activeTabId={currentTabId} renderLinks>
            <Tabs sections={[{ id: 'solutions' }, { id: 'contact' }]}>
              <Tab className={styles.submenuTab} href='/solutions/features' tabId='solutions'>
                Features
              </Tab>
              <Tab className={styles.submenuTab} href='/solutions/contact' tabId='contact'>
                {t('PAGE_TITLE_CONTACT')}
              </Tab>
            </Tabs>
          </TabsContextProvider>
        );
      case 'OK':
        return (
          <TabsContextProvider activeTabId={currentTabId} renderLinks>
            <Tabs sections={[{ id: 'about' }, { id: 'news' }, { id: 'workWithUs' }]}>
              <Tab className={styles.submenuTab} href='/solutions/about' tabId='about'>
                {t('PAGE_TITLE_ABOUT')}
              </Tab>
              <Tab className={styles.submenuTab} href='/solutions/news' tabId='news'>
                News and events
              </Tab>
              <Tab className={styles.submenuTab} href='/solutions/work-with-us' tabId='workWithUs'>
                {t('PAGE_TITLE_WORK_WITH_US')}
              </Tab>
            </Tabs>
          </TabsContextProvider>
        );
      case t('PAGE_GROUP_TITLE_LEGAL'):
        return (
          <TabsContextProvider activeTabId={currentTabId} renderLinks>
            <Tabs sections={[{ id: 'terms' }]}>
              <Tab className={styles.submenuTab} href='/solutions/terms' tabId='terms'>
                {t('PAGE_TITLE_TERMS')}
              </Tab>
            </Tabs>
          </TabsContextProvider>
        );
      case 'More':
        return (
          <TabsContextProvider activeTabId={currentTabId} renderLinks>
            <Tabs sections={[{ id: 'status' }]}>
              <Tab
                className={styles.submenuTab}
                href='https://stats.uptimerobot.com/g6q6Dcq4WV'
                tabId='status'
                target='_blank'
              >
                Status
              </Tab>
            </Tabs>
          </TabsContextProvider>
        );
      default:
        return null;
    }
  }, [activeSectionTitle, currentTabId, t]);

  return (
    <Menu>
      <PageMenu
        activeSectionTitle={activeSectionTitle}
        onActiveSectionChange={onChangeActiveSection}
        sections={[{ title: 'Help' }, { title: 'OK' }, { title: t('PAGE_GROUP_TITLE_LEGAL') }, { title: 'More' }]}
        submenu={pageMenuSubmenu}
      />
    </Menu>
  );
}

StaticPagesMenu.propTypes = {
  currentSectionTitle: PropTypes.string.isRequired,
  currentTabId: PropTypes.string.isRequired,
};
